// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__28xpq","content":"styles_content__1MlDi","selectAll":"styles_selectAll__1NdtM"};